export function genPromise() {
    let resolve;
    const promise = new Promise((r) => (resolve = r));
    return { promise, resolve };
}
